// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"b7194884","703":"509f524b"}[chunkId] + ".chunk.js";
};